import { render, staticRenderFns } from "./RegisterWithEmail.vue?vue&type=template&id=4d9525d0&scoped=true&"
import script from "./RegisterWithEmail.vue?vue&type=script&lang=js&"
export * from "./RegisterWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWithEmail.vue?vue&type=style&index=0&id=4d9525d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9525d0",
  null
  
)

export default component.exports